import React, { memo } from 'react';
import { Box, Skeleton } from '@mui/material';
import { SanitizedHTML } from '@alycecom/ui';

export interface INeedMoreInfoMessageProps {
  message?: string;
  isLoading?: boolean;
}

const NeedMoreInfoMessage = ({ message = '', isLoading = false }: INeedMoreInfoMessageProps) => {
  // Removed empty paragraph blocks from email chunk.
  const preparedMessage = message.replace(/<p>&nbsp;<\/p>/g, '');
  return (
    <Box minHeight={120} width={1} textAlign="left">
      {isLoading ? (
        <>
          <Skeleton height={32} />
          <Skeleton height={32} />
          <Skeleton height={32} width="50%" />
        </>
      ) : (
        <SanitizedHTML className="Body-Regular-Left-Static" html={preparedMessage} />
      )}
    </Box>
  );
};

export default memo(NeedMoreInfoMessage);
